import React from 'react';

const About = () => {
  return (
    <div className="page">
      <h1>About Us</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default About; 